import { get } from 'lodash'

export default function(data) {
  const result = {}

  if (data) {
    result.helpers = {
      category: get(data, 'activityCategory.parent.id'),
      subcategory: get(data, 'activityCategory.id')
    }
    result.goal = get(data, 'goal')
    result.startDate = get(data, 'startDate')
    result.endDate = get(data, 'endDate')
    result.projectLocationType = get(data, 'projectLocationType')
    result.locationDetail = get(data, 'locationDetail')
    result.note = get(data, 'note')
    result.assessorEmail = get(data, 'assessorEmail')
    result.assessorPhone = get(data, 'assessorPhone')
    result.assessorTitle = get(data, 'assessorTitle')
    result.assessorName = get(data, 'assessorName')
    result.configuration = get(data, 'configuration')
  }

  return result
}

